{
    document.addEventListener("DOMContentLoaded", function() {
        fetch('https://get.geojs.io/v1/ip/country')
            .then(response => response.text())
            .then(countryCode => {
                var userLocation = countryCode.trim();
                if (userLocation !== 'US') {
                    var attentiveForms = document.querySelector('.js-attentive-form-wrapper iframe');
                    if (attentiveForms) attentiveForms.remove();
                }
                else {
                    var internationalText = document.querySelector('.js-international-text');
                    if (internationalText) internationalText.remove();
                }
            })
            .catch(error => {
                console.error('Error fetching country code:', error);
            });
    });
}